import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-reasonstudios',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Reason Studios icon</title><path d="M2.49 5.114l8.3-4.79a2.421 2.421 0 012.39-.017l.03.017 8.299 4.79c.74.427 1.2 1.212 1.211 2.065V16.79c0 .854-.451 1.645-1.184 2.08l-.027.016-8.299 4.79a2.42 2.42 0 01-2.39.017l-.03-.017-8.3-4.79a2.421 2.421 0 01-1.21-2.065V7.21c0-.855.45-1.645 1.184-2.08l.026-.016 8.3-4.79zM12 4.026L5.092 8.013v7.974L12 19.974V12l6.908-3.987z"/></svg>`,
    styles: []
})
export class SimpleIconsReasonstudiosComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FFFFFF';
    @Input() className: string = 'simple-icons-reasonstudios'
    constructor() {}
    ngOnInit(): void {}
}
